import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Checkbox as SemanticCheckbox,
  Input as SemanticInput,
} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Label = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 600;
`;

export const Input = styled(SemanticInput)<{$wide?: boolean}>`
  ${({$wide}) => $wide && `width: 100%;`}
`;

export const CheckboxRow = styled.div``;

export const CheckboxRowInner = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const Checkbox = styled(SemanticCheckbox)``;

export const CheckboxLabel = styled.label`
  margin-left: 8px;
  cursor: pointer;
`;

export const Dropdown = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
`;

export const DropdownIcon = styled(Icon)`
  font-size: 20px;
  margin-left: 2px;
  margin-top: 2px;
`;
